import { render } from "./LegendEntry.vue?vue&type=template&id=6428bf16&scoped=true"
import script from "./LegendEntry.vue?vue&type=script&lang=js"
export * from "./LegendEntry.vue?vue&type=script&lang=js"

import "./LegendEntry.vue?vue&type=style&index=0&id=6428bf16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6428bf16"]])

export default __exports__